<template>
    <h1 class="title-logo">Заказы</h1>
    <div v-if="user.id > 0" class="orders-list clx scrollable js-scroll">
        <div class="order-item">
            <div class="order-item__header"><a class="order-item__title" href="javascript:;">Заказ №261 от 12.12.2022</a>
                <div class="order-item__state order-item__state--wait"><svg class="svg-icon-wait svg-icon" width="11" height="18">
                    <use xlink:href="#wait"></use>
                </svg>Сбор предложений от поставщиков</div>
            </div>
        </div>
        <div class="order-item">
            <div class="order-item__header"><a class="order-item__title" href="javascript:;">Заказ №261 от 12.12.2022</a>
                <div class="order-item__state order-item__state--wait"><svg class="svg-icon-delivery svg-icon" width="22" height="20">
                    <use xlink:href="#delivery"></use>
                </svg>Доставка</div>
            </div><button class="order-item__notify js-data-popup-open" type="button"><svg class="svg-icon-envelope svg-icon" width="24" height="18">
            <use xlink:href="#envelope"></use>
        </svg><span class="order-item__notify-count">2</span></button>
            <div class="data-popup js-data-popup">
                <div class="data-popup__header"><button class="data-popup__close-btn js-data-popup-close" type="button"><svg class="svg-icon-close svg-icon" width="20" height="20">
                    <use xlink:href="#close"></use>
                </svg></button></div>
                <div class="message">Будет обращать внимание пользователя на то что в заказе произошла активность и ему необходимо прочитать ее</div>
                <div class="message">Будет обращать внимание пользователя на то что в заказе произошла активность и ему необходимо прочитать ее</div>
                <div class="bottom-section"><button class="primary-btn lg-btn wide-btn js-data-popup-close" type="button"><span>ОK</span></button></div>
            </div>
        </div>
        <div class="order-item">
            <div class="order-item__header"><a class="order-item__title" href="javascript:;">Заказ №261 от 12.12.2022</a>
                <div class="order-item__state order-item__state--canceled"><svg class="svg-icon-cancel svg-icon" width="16" height="16">
                    <use xlink:href="#cancel"></use>
                </svg>Отменён</div>
            </div>
        </div>
        <div class="order-item">
            <div class="order-item__header"><a class="order-item__title" href="javascript:;">Заказ №261 от 12.12.2022</a>
                <div class="order-item__state order-item__state--success"><svg class="svg-icon-done svg-icon" width="16" height="16">
                    <use xlink:href="#done"></use>
                </svg>Завершён</div>
            </div><button class="order-item__notify js-data-popup-open" type="button"><svg class="svg-icon-envelope svg-icon" width="24" height="18">
            <use xlink:href="#envelope"></use>
        </svg><span class="order-item__notify-count">1</span></button>
            <div class="data-popup js-data-popup">
                <div class="data-popup__header"><button class="data-popup__close-btn js-data-popup-close" type="button"><svg class="svg-icon-close svg-icon" width="20" height="20">
                    <use xlink:href="#close"></use>
                </svg></button></div>
                <div class="message">Будет обращать внимание пользователя на то что в заказе произошла активность и ему необходимо прочитать ее</div>
                <div class="bottom-section"><button class="primary-btn lg-btn wide-btn js-data-popup-close" type="button"><span>ОK</span></button></div>
            </div>
        </div>
    </div>

    <p v-else>Для просмотра списка ваших заказов вам необходимо пройти  <router-link to="/auth">авторизацию</router-link></p>

</template>

<script>

    import IMask from 'imask';

    export default {

        name: 'Orders',

        data: function(){
            return {

            };
        },

        computed: {
            user: function () {
                return this.$store.getters.getUser;
            },
        },

        created() {
            this.$root.scrollable = false;
            this.$root.pageClass = "";
        },

        mounted:function () {

        },

        components: {},

        methods: {}
    }
</script>
